/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// eslint-disable-next-line no-unused-vars
import * as runtime from '../runtime';
// eslint-disable-next-line no-unused-vars
import {
    ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    IdeaVoteUpdateAdmin,
    IdeaVoteUpdateAdminFromJSON,
    IdeaVoteUpdateAdminToJSON,
    IdeaVoteUpdateAdminResponse,
    IdeaVoteUpdateAdminResponseFromJSON,
    IdeaVoteUpdateAdminResponseToJSON,
} from '../models';

export interface IdeaVoteUpdateAdminRequest {
    projectId: string;
    ideaId: string;
    ideaVoteUpdateAdmin: IdeaVoteUpdateAdmin;
}

/**
 * no description
 */
export interface VoteAdminApiInterface {

    /**
     */
    ideaVoteUpdateAdmin(requestParameters: IdeaVoteUpdateAdminRequest, headerExtra?:{[key:string]:string}): Promise<IdeaVoteUpdateAdminResponse>;
}

/**
 * no description
 */
export class VoteAdminApi extends runtime.BaseAPI implements VoteAdminApiInterface {

    /**
     */
    async ideaVoteUpdateAdminRaw(requestParameters: IdeaVoteUpdateAdminRequest, headerExtra?:{[key:string]:string}): Promise<runtime.ApiResponse<IdeaVoteUpdateAdminResponse>> {
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId','Required parameter requestParameters.projectId was null or undefined when calling ideaVoteUpdateAdmin.');
        }

        if (requestParameters.ideaId === null || requestParameters.ideaId === undefined) {
            throw new runtime.RequiredError('ideaId','Required parameter requestParameters.ideaId was null or undefined when calling ideaVoteUpdateAdmin.');
        }

        if (requestParameters.ideaVoteUpdateAdmin === null || requestParameters.ideaVoteUpdateAdmin === undefined) {
            throw new runtime.RequiredError('ideaVoteUpdateAdmin','Required parameter requestParameters.ideaVoteUpdateAdmin was null or undefined when calling ideaVoteUpdateAdmin.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = headerExtra || {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/project/{projectId}/admin/vote/idea/{ideaId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"ideaId"}}`, encodeURIComponent(String(requestParameters.ideaId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: IdeaVoteUpdateAdminToJSON(requestParameters.ideaVoteUpdateAdmin),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => IdeaVoteUpdateAdminResponseFromJSON(jsonValue));
    }

    /**
     */
    async ideaVoteUpdateAdmin(requestParameters: IdeaVoteUpdateAdminRequest, headerExtra?:{[key:string]:string}): Promise<IdeaVoteUpdateAdminResponse> {
        const response = await this.ideaVoteUpdateAdminRaw(requestParameters, headerExtra);
        return await response.value();
    }

}
